// Mock data for Clean Cars Alsace website

export const contactInfo = {
  phone: "06.61.99.41.39",
  email: "clean.cars.alsace@gmail.com",
  address: "Route de Colmar, Sélestat 67600",
  hours: "7j/7j - 24h/24h",
  serviceArea: "Toute l'Alsace"
};

export const services = [
  {
    id: 1,
    title: "Nettoyage Automobile",
    description: "Nettoyage intérieur et extérieur complet, lustrage, polish, traitement céramique",
    icon: "Car",
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/z6uypno3_10.jpeg",
    price: "À partir de 70€"
  },
  {
    id: 6,
    title: "Détailing Intérieur",
    description: "Nettoyage complet intérieur véhicule, sièges, tapis, plastiques",
    icon: "Sparkles",
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/m8gpyafy_3.jpeg",
    price: "À partir de 70€"
  },
  {
    id: 2,
    title: "Terrasses",
    description: "Nettoyage haute pression de terrasses, allées, cours et espaces extérieurs",
    icon: "Home",
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/1jdl5xka_11.jpeg",
    price: "Sur devis"
  },
  {
    id: 3,
    title: "Murets & Portails",
    description: "Nettoyage et rénovation de murets, portails et clôtures",
    icon: "Fence",
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/kzx9ctou_2.jpeg",
    price: "Sur devis"
  },
  {
    id: 4,
    title: "Canapés & Fauteuils",
    description: "Nettoyage en profondeur de tous types de tissus d'ameublement",
    icon: "Armchair",
    image: "https://images.unsplash.com/photo-1768946131690-247c5319f0d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxzb2ZhJTIwY2xlYW5pbmclMjB1cGhvbHN0ZXJ5JTIwcHJvZmVzc2lvbmFsfGVufDB8fHx8MTc3MjY1MDQzMHww&ixlib=rb-4.1.0&q=85",
    price: "Sur devis"
  },
  {
    id: 5,
    title: "Tapis & Moquettes",
    description: "Traitement et nettoyage professionnel de tapis et moquettes",
    icon: "Layers",
    image: "https://images.pexels.com/photos/4107278/pexels-photo-4107278.jpeg",
    price: "Sur devis"
  }
];

export const gallery = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/z6uypno3_10.jpeg",
    category: "Automobile",
    title: "Carrosserie Extérieure - Avant/Après",
    type: "before-after"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/8o36ef2b_6.jpeg",
    category: "Automobile",
    title: "Nettoyage Intérieur Complet - Avant/Après",
    type: "before-after"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/m8gpyafy_3.jpeg",
    category: "Automobile",
    title: "Sièges Arrière - Avant/Après",
    type: "before-after"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/czici28x_7.jpeg",
    category: "Automobile",
    title: "Détails Sièges - Avant/Après",
    type: "before-after"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/lw0qgliv_15.jpeg",
    category: "Automobile",
    title: "Tapis de Coffre - Avant/Après",
    type: "before-after"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/nqxhjwlx_5.jpeg",
    category: "Automobile",
    title: "Plastiques Intérieurs - Avant/Après",
    type: "before-after"
  },
  {
    id: 7,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/kzx9ctou_2.jpeg",
    category: "Extérieur",
    title: "Portail - Avant/Après",
    type: "before-after"
  },
  {
    id: 8,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/66g9qs6v_13.jpeg",
    category: "Extérieur",
    title: "Sigle Doré Portail - Avant/Après",
    type: "before-after"
  },
  {
    id: 9,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/lpf7hfxz_8.jpeg",
    category: "Extérieur",
    title: "Muret - Avant/Après",
    type: "before-after"
  },
  {
    id: 10,
    image: "https://customer-assets.emergentagent.com/job_clean-cars-alsace/artifacts/1jdl5xka_11.jpeg",
    category: "Extérieur",
    title: "Terrasse - Avant/Après",
    type: "before-after"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Charles Daudré-Vignier",
    location: "Google - Local Guide",
    rating: 5,
    text: "J'ai fait appel à Clean Cars Alsace pour l'aspiration de ma voiture. L'état initial était déplorable: tabac à rouler pris dans les fibres de tapis et dispersé partout, sable, poussière, etc. J'ai récupéré ma voiture 1h après, le nettoyage était parfait. L'intégralité de la prestation, de la communication au nettoyage, était remarquable !",
    service: "Aspiration Intérieur",
    date: "Avril 2025",
    platform: "google"
  },
  {
    id: 2,
    name: "Schwoerer Aurélie",
    location: "Google",
    rating: 5,
    text: "J'ai fait appel aux services de Clean Cars et je suis très très satisfaite des soins apportés à mon véhicule. Travail soigné, ponctuel, gentil et fort agréable. Je vous recommande ce jeune homme pour son professionnalisme !",
    service: "Nettoyage Automobile",
    date: "Avril 2025",
    platform: "google"
  },
  {
    id: 2,
    name: "CAGLIYANLAR Nazife",
    location: "Google",
    rating: 5,
    text: "J'ai fait appel Clean cars Alsace pour le nettoyage des sièges de ma voiture. Le résultat était très satisfaisant, il a fait un excellent travail.",
    service: "Nettoyage Sièges",
    date: "Mars 2025",
    platform: "google"
  },
  {
    id: 3,
    name: "Alexandre Schrotz",
    location: "Google",
    rating: 5,
    text: "Je recommande fortement. Le avant après de ma voiture c'est méconnaissable. Très pro rapide et efficace en plus facilement joignable...",
    service: "Nettoyage Automobile",
    date: "Février 2025",
    platform: "google"
  },
  {
    id: 2,
    name: "Anne Iltis",
    location: "Facebook",
    rating: 5,
    text: "Je recommande vivement Jérémie car il est une très belle personne, il a un très bon professionnalisme qui a redonné tout son éclat et a pris soin de mon véhicule à mon étonnante, ponctuel, persévérant, travail soigné, très satisfaisant, impeccable. Minutieux, respectueux, dynamique, agréable, et surtout honnête",
    service: "Nettoyage Complet",
    date: "Juillet 2025",
    platform: "facebook"
  },
  {
    id: 3,
    name: "Margot Pierre",
    location: "Google",
    rating: 5,
    text: "Un travail irréprochable réalisé par un vrai passionné !...",
    service: "Nettoyage Professionnel",
    date: "Avril 2025",
    platform: "google"
  },
  {
    id: 4,
    name: "Brigitte Sette",
    location: "Google",
    rating: 5,
    text: "Très professionnel, consciencieux, sérieux et à l'écoute. Du très bon travail..et il y avait du boulot! ...avec les poils de mes chiens 🐕...nous recommandons vivement...",
    service: "Nettoyage Intérieur",
    date: "Juillet 2025",
    platform: "google"
  },
  {
    id: 5,
    name: "Carine Weinbissinger",
    location: "Facebook & Google",
    rating: 5,
    text: "Je suis vraiment satisfaite du service de Clean Cars ! Ma voiture a été nettoyée intérieure et extérieure de manière impeccable. Le résultat est impressionnant, ma voiture paraît comme neuve !",
    service: "Nettoyage Complet",
    date: "Mai 2025",
    platform: "both"
  },
  {
    id: 6,
    name: "Gilles Berra",
    location: "Facebook & Google",
    rating: 5,
    text: "R.a.s travail au top pour une première expérience sur un camion ! On hésitera pas une seconde à refaire appel à vos services, bonne continuation sur ce chemin !",
    service: "Nettoyage Camion",
    date: "Mai 2025",
    platform: "both"
  },
  {
    id: 7,
    name: "Martine Lemble",
    location: "Facebook",
    rating: 5,
    text: "Nettoyage de mon véhicule intérieur, et ça en valait le coup 😱!! Résultat plus que satisfaisant, personne agréable, professionnel et minutieux. J'espère que ma voiture ne vous fera pas faire de cauchemars 😂😂",
    service: "Détailing Intérieur",
    date: "Mai 2025",
    platform: "facebook"
  },
  {
    id: 8,
    name: "Françoise Boureau",
    location: "Facebook",
    rating: 5,
    text: "Super prestataire, Jeremie est au top, il est très professionnel je recommande à 200 %. Travail sérieux et réalisé proprement",
    service: "Nettoyage Automobile",
    date: "Mai 2025",
    platform: "facebook"
  },
  {
    id: 9,
    name: "Vivien Jeanselme",
    location: "Google",
    rating: 5,
    text: "J'ai fait appel Clean Cars pour ma voiture et le résultat splendide. Une voiture aussi propre que si elle était neuve, professionnalisme et gentillesse je recommande",
    service: "Nettoyage Automobile",
    date: "Avril 2025",
    platform: "google"
  },
  {
    id: 10,
    name: "Alen Muhic",
    location: "Facebook",
    rating: 5,
    text: "Ce mec là est au top ! Très sérieux et surtout à l'écoute du client. Croyez moi, vous ne pouvez qu'être satisfait après son nettoyage. Merci CHEF 🙏",
    service: "Nettoyage Automobile",
    date: "Septembre 2024",
    platform: "facebook"
  },
  {
    id: 11,
    name: "François Berthier",
    location: "Google",
    rating: 5,
    text: "Très bon travail. La voiture est comme neuve. Merci",
    service: "Nettoyage Automobile",
    date: "Octobre 2024",
    platform: "google"
  },
  {
    id: 12,
    name: "Serpi'Dog & Co",
    location: "Facebook",
    rating: 5,
    text: "Un travail irréprochable réalisé par un vrai passionné ! Ma voiture que j'utilisais pour mon usage professionnel...",
    service: "Nettoyage Professionnel",
    date: "Mai 2025",
    platform: "facebook"
  }
];

export const mockAppointments = [];
export const mockQuotes = [];
export const mockContacts = [];
